
import Vue from 'vue'
import { Textbox } from '@/components/formGroups'
import ChooseSchool from './PaymentMethodChooseSchool.vue'

export default Vue.extend({
   name: 'PaymentMethodSchoolCharge',
   data() {
      return {
         orderNumber: '',
         attention: '',
      }
   },
   computed: {
      showErrors(): boolean {
         return this.$store.state.showErrors
      },
   },
   methods: {
      update() {
         this.$store.commit('setSchoolInvoiceData', {
            orderNumber: this.orderNumber,
            attention: this.attention,
         })
      },
   },
   components: {
      Textbox,
      ChooseSchool,
   },
})
